/** Evento CRM: operador devolvió la conversación al asistente automático (Anita). */
export const CONVERSATION_RETURN_TO_BOT_EVENT = 'pulse:conversation-return-to-bot';

/**
 * @param {{ conversationId: string|number, fase?: string, assignee?: object|null }} detail
 */
export function dispatchConversationReturnToBot(detail) {
  if (typeof window === 'undefined' || detail?.conversationId == null) return;
  window.dispatchEvent(
    new CustomEvent(CONVERSATION_RETURN_TO_BOT_EVENT, {
      detail: {
        ...detail,
        conversationId: String(detail.conversationId)
      }
    })
  );
}
